import VipService from '../../service/vip';
import VisitAddressService from '../../service/visitAddress';

const Action = {
    CHOOSE_PLAN: "CHOOSE_PLAN",
    SET_VIP: "SET_VIP",
    GET_VIP: "GET_VIP",
    GET_COMPANY_VIP: "GET_COMPANY_VIP",
    GET_VIP_ERROR: "GET_VIP_ERROR",
    GET_VIPS: "GET_VIPS",
    SET_NUMBER_OF_RECORDS: "SET_NUMBER_OF_RECORDS",
    SET_COMPANY_VIPS: "SET_COMPANY_VIPS",
    GET_COMPANY_VIPS: "GET_COMPANY_VIPS",
    NEW_VIP: "NEW_VIP",
    UPDATE_VIP: "UPDATE_VIP",
    DISABLE_VIP: "DISABLE_VIP",
    CSV_UPLOAD_COMPANY_VIPS: "CSV_UPLOAD_COMPANY_VIPS",
};

const ActionCreator = {

    addVip(vip) {
        return async (dispatch) => {
            try {
                const newVip = await VipService.addVip(vip);
                dispatch({type: Action.NEW_VIP, vip: newVip});
                return newVip;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getVip(vipId) {
        return async (dispatch) => {
            try {
                const vip = await VipService.findById(vipId);
                dispatch({type: Action.GET_VIP, vip});
                return vip;
            } catch (error) {
                // 將 error 丟給 httpResponseErrorHandler 處理 , 之後將結果向外拋出
                throw dispatch({type: Action.GET_VIP_ERROR, error});
            }
        };
    },
    setVip(vip) {
        return async (dispatch) => {
            try {
                dispatch({type: Action.SET_VIP, vip});
                return vip;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getVips(params) {
        return async (dispatch) => {
            try {
                const { vips, numberOfRecords } = await VipService.list(params)
                dispatch({type: Action.GET_VIPS, vips, numberOfRecords, params})
                return vips
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    refreshVips() {
        return async (dispatch, getState) => {
            return await dispatch(ActionCreator.getVips(getState().vip.lastGetVipsParams))
        }
    },
    setCompanyVips(companyVips) {
        return async (dispatch) => {
            try {
                dispatch({type: Action.SET_COMPANY_VIPS, companyVips});
                return companyVips;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getCompanyVips(companyId) {
        return async (dispatch) => {
            try {
                const vips = await VipService.list();

                const companyVips = vips.filter((vip) => {
                    return vip.group.type.label === 'company';
                }).filter((vip) => {
                    if (!companyId) return true;
                    return vip.group.company.id === companyId;
                });

                dispatch({type: Action.GET_COMPANY_VIPS, companyVips});
                return vips;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    changePassword({vipId, password}) {
        return async (dispatch) => {
            try {
                const newVip = await VipService.changePassword({vipId, password});
                dispatch({type: Action.UPDATE_VIP, vip: newVip});
                return newVip;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    avatarGetUrl({base64Image}) {
        return async (dispatch) => {
            try {
                return await VipService.avatarGetUrl({base64Image});
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    updateVip(vip) {
        return async (dispatch) => {
            try {
                const newVip = await VipService.updateVip(vip);
                dispatch({type: Action.UPDATE_VIP, vip: newVip});
                return newVip;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    vipChoosePlan({vipId, pricePlan}) {
        return async (dispatch) => {
            try {
                let msg = await VipService.vipChoosePlan({vipId, pricePlan});
                return msg;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    vipJoinClub({missionTypeId, period_in_milliseconds = 0, points, groupType, vipId}) {
        // period (加點頻率) => 可選擇項為 1天 . 1個月 . 1年 , 0 代表立即加點

        return async (dispatch) => {
            try {
                await VipService.vipJoinClub({vipId, missionTypeId, period_in_milliseconds, points, groupType});
                return dispatch(ActionCreator.getVip(vipId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    companyVipJoinClub({missionTypeId, period_in_milliseconds = 24 * 60 * 60 * 1000, points, vipId}) {
        // period (加點頻率) => 可選擇項為 1天 . 1個月 . 1年 , 0 代表立即加點

        return async (dispatch) => {
            try {
                await VipService.companyVipJoinClub({vipId, missionTypeId, period_in_milliseconds, points});
                return dispatch(ActionCreator.getVip(vipId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    plusUseRecord({missionTypeId, points, vipId, groupType, point_action}) {
        // period (加點頻率) => 可選擇項為 1天 . 1個月 . 1年 , 0 代表立即加點

        const period_in_milliseconds = (groupType.label === 'company') ? 24 * 60 * 60 * 1000 : 0;
        const newPoint = (point_action === '加點') ? points : points * (-1);

        return async (dispatch) => {
            try {
                await VipService.plusUseRecord({vipId, missionTypeId, period_in_milliseconds, points: newPoint});
                return dispatch(ActionCreator.getVip(vipId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    enableVisitAddress({visitAddressId, vipId}) {
        return async (dispatch) => {
            try {
                await VisitAddressService.enable(visitAddressId);
                return dispatch(ActionCreator.getVip(vipId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    disableVip(vipId) {
        return async (dispatch) => {
            try {
                await VipService.disableVip(vipId);
                return dispatch(ActionCreator.getVip(vipId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    enableVip(vipId) {
        return async (dispatch) => {
            try {
                await VipService.enable(vipId);
                return dispatch(ActionCreator.getVip(vipId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    notifiedVip(vipId) {
        return async (dispatch) => {
            try {
                await VipService.notifiedVip(vipId);
                return dispatch(ActionCreator.getVip(vipId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    validateVipEmail(vipId) {
        return async (dispatch) => {
            try {
                await VipService.validateVipEmail(vipId);
                return dispatch(ActionCreator.getVip(vipId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    sendSurvey2020(vipId) {
        return async (dispatch) => {
            try {
                await VipService.sendSurvey2020(vipId);
                return dispatch(ActionCreator.getVip(vipId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    sendCustomMail({ vipId, subject, content }) {
        return async (dispatch) => {
            try {
                await VipService.sendCustomMail({ vipId, subject, content });
                return dispatch(ActionCreator.getVip(vipId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    autoVerifyOcc({ vipId, occId, areaCode }) {
        return async (dispatch) => {
            try {
                await VipService.autoVerifyOcc({ vipId, id: occId, areaCode });
                return dispatch(ActionCreator.getVip(vipId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    updateOccVerifyStatus({ vipId, occId, areaCode, isVerified }) {
        return async (dispatch) => {
            try {
                await VipService.updateOccVerifyStatus({ vipId, id: occId, areaCode, isVerified });
                return dispatch(ActionCreator.getVip(vipId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    convertCsvToVips(jsonData) {
        return async (dispatch) => {

            const vips = jsonData.map(function (jsonRowDate) {

                // transform csv data to vip
                const user = {
                    family_name: jsonRowDate['姓'],
                    given_name: jsonRowDate['名'],
                    name: jsonRowDate['姓'] + jsonRowDate['名'],
                    password: jsonRowDate['預設密碼'],
                    id_no: jsonRowDate['身分證字號'],
                    email: jsonRowDate['email'],
                    nickname: jsonRowDate['暱稱'],
                    cell_phone_no: jsonRowDate['手機號碼'],
                    sex: jsonRowDate['性別'],
                    birthday: jsonRowDate['生日'],
                    blood_type: jsonRowDate['血型'],
                    avatar: {
                        url: 'https://res.cloudinary.com/uecare/image/upload/v1524205226/DefaultImage/vipHead_3x.png'
                    }
                };

                const vip = {
                    user,
                    habit: jsonRowDate['習慣'],
                    ill_history: jsonRowDate['病史'],
                    status: {},
                    group: {}
                };

                return vip;
            });

            dispatch({type: Action.CSV_UPLOAD_COMPANY_VIPS, companyVips: vips});
            return vips;
        };
    },

    removePlan(vipId) {
        return async (dispatch) => {
            try {
                await VipService.removePlan(vipId);
                return dispatch(ActionCreator.getVip(vipId));
            } catch (error) {
                throw dispatch({ error })
            }
        }
    },
};


const initialState = {
    companyVips: [],
    vips: [],
    vip: {},
    numberOfRecords: 0,
    lastGetVipsParams: {
        limit: 0,
        offset: 10,
        searchField: '',
        searchKeyword: '',
    },
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.SET_VIP:
        case Action.GET_VIP:
        case Action.NEW_VIP:
        case Action.DISABLE_VIP:
        case Action.UPDATE_VIP:
            return {
                ...state,
                vip: action.vip
            };
        case Action.GET_VIPS:
            return {
                ...state,
                vips: action.vips,
                numberOfRecords: action.numberOfRecords,
                lastGetVipsParams: action.params,
            };
        case Action.SET_NUMBER_OF_RECORDS:
            return {
                ...state,
                numberOfRecords: action.numberOfRecords,
            }
        case Action.CSV_UPLOAD_COMPANY_VIPS:
        case Action.SET_COMPANY_VIPS:
        case Action.GET_COMPANY_VIPS:
            return {
                ...state,
                companyVips: action.companyVips
            };
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/vip.js